import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { ButtonBase, CircularProgress, Menu, MenuItem } from '@mui/material';
import { useRef, useState } from 'react';
import { CustomAttributeValue } from 'src/graphql/entities/custom-attributes/custom-attributes.types';
import { CustomAttributeEditProps } from 'src/graphql/entities/custom-attributes/field-view-registry/types';
import { getKindLikeValueSafely } from 'src/graphql/entities/custom-attributes/field-view-registry/utils';
import { YesNoPill } from './yes-no-pill';

const OPTIONS: readonly boolean[] = [true, false];

export const CheckboxEditor = ({
  value,
  onChange,
  onSave,
  disabled,
  saving,
}: CustomAttributeEditProps) => {
  const checked = getKindLikeValueSafely(value, 'checkbox') === true;
  const anchorRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);

  const handleSelect = (next: boolean) => {
    setOpen(false);
    if (next === checked) {
      return;
    }

    const updated: CustomAttributeValue = { kind: 'checkbox', value: next };

    onChange(updated);
    onSave(updated);
  };

  return (
    <>
      <ButtonBase
        ref={anchorRef}
        disabled={disabled}
        onClick={() => setOpen(true)}
        focusRipple
        sx={{ borderRadius: '999px', '&.Mui-disabled': { opacity: 0.6 } }}
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        <YesNoPill
          value={checked}
          sx={{ cursor: disabled ? 'default' : 'pointer', pr: '0.25rem' }}
          trailing={
            saving ? (
              <CircularProgress size="0.875rem" sx={{ mx: '0.375rem' }} />
            ) : (
              <ArrowDropDownIcon sx={{ ml: '0.125rem' }} />
            )
          }
        />
      </ButtonBase>
      <Menu
        anchorEl={anchorRef.current}
        open={open}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        slotProps={{ paper: { sx: { mt: 0.5 } } }}
      >
        {OPTIONS.map((optionValue) => (
          <MenuItem
            key={String(optionValue)}
            selected={optionValue === checked}
            onClick={() => handleSelect(optionValue)}
          >
            <YesNoPill value={optionValue} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
